import React, { useEffect, useState, useMemo } from "react"
import { Modal } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import { usePermissions } from "API/PermissionContext"

const arr = d => { const v = d?.data?.data ?? d?.data ?? d; return Array.isArray(v) ? v : [] }

const CCSpoiledPurchases = () => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CC_SPOILED

  // - core state -
  const [activeTab, setActiveTab] = useState("active")
  const [records, setRecords] = useState([])
  const [deletedRecords, setDeletedRecords] = useState([])
  const [pageLoad, setPageLoad] = useState(true)
  const [selected, setSelected] = useState([])
  const [searchTxt, setSearchTxt] = useState("")
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [delPage, setDelPage] = useState(1)
  const [delTotalPages, setDelTotalPages] = useState(1)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dlgMsg, setDlgMsg] = useState("")

  // - companies (for cascading) -
  const [companies, setCompanies] = useState([])
  const [multiCompany, setMultiCompany] = useState(false)

  // - ADD modal state -
  const [addOpen, setAddOpen] = useState(false)
  const [addCompany, setAddCompany] = useState("")
  const [addPlant, setAddPlant] = useState("")
  const [addCC, setAddCC] = useState("")
  const [addDate, setAddDate] = useState(new Date().toISOString().slice(0,10))
  const [addShift, setAddShift] = useState("0")
  const [addQP, setAddQP] = useState(true)    // Quality Parameters
  const [addCR, setAddCR] = useState(false)   // Custom Rate
  const [addCI, setAddCI] = useState(false)   // Custom Incentive
  const [addPlants, setAddPlants] = useState([])
  const [addCCs, setAddCCs] = useState([])
  const [addShowTable, setAddShowTable] = useState(false)
  const [addRows, setAddRows] = useState([])
  const [addSaving, setAddSaving] = useState(false)

  // - EDIT modal state -
  const [editOpen, setEditOpen] = useState(false)
  const [editId, setEditId] = useState(null)
  const [editData, setEditData] = useState({})
  const [editLoading, setEditLoading] = useState(false)
  const [editSaving, setEditSaving] = useState(false)
  const [editPlants, setEditPlants] = useState([])
  const [editCCs, setEditCCs] = useState([])
  const [editRoutes, setEditRoutes] = useState([])
  const [editVendors, setEditVendors] = useState([])

  // - UPDATE modal state -
  const [upOpen, setUpOpen] = useState(false)
  const [upCompany, setUpCompany] = useState("")
  const [upPlant, setUpPlant] = useState("")
  const [upCC, setUpCC] = useState("")
  const [upRoute, setUpRoute] = useState("")
  const [upVendor, setUpVendor] = useState("")
  const [upDisplay, setUpDisplay] = useState("single")
  const [upDate, setUpDate] = useState(new Date().toISOString().slice(0,10))
  const [upPeriodFrom, setUpPeriodFrom] = useState("")
  const [upPeriodTo, setUpPeriodTo] = useState("")
  const [upShift, setUpShift] = useState("0")
  const [upCR, setUpCR] = useState(true)
  const [upPlants, setUpPlants] = useState([])
  const [upCCs, setUpCCs] = useState([])
  const [upRoutes, setUpRoutes] = useState([])
  const [upVendors, setUpVendors] = useState([])
  const [upPreviewRows, setUpPreviewRows] = useState([])
  const [upOrigRows, setUpOrigRows] = useState([])
  const [upLoading, setUpLoading] = useState(false)
  const [upSaving, setUpSaving] = useState(false)

  // - FILTER state -
  const [showFilter, setShowFilter] = useState(false)
  const [fDate, setFDate] = useState("")
  const [fDateTo, setFDateTo] = useState("")
  const [fCC, setFCC] = useState("")
  const [fShift, setFShift] = useState("")

  // - init -
  useEffect(() => {
    (async () => {
      try {
        const c = arr(await api.get("companies"))
        setCompanies(c); setMultiCompany(c.length > 1)
      } catch(e){}
      loadData(1)
    })()
  }, [])

  // - data loading -
  const loadData = async (p) => {
    setPageLoad(true); setSelected([])
    try {
      const resp = await api.get("cc-spoiled-purchases?per_page=200&page=" + (p||1))
      const d = resp.data?.data
      setRecords(d?.data || arr(resp))
      setPage(d?.current_page || 1)
      setTotalPages(d?.last_page || 1)
    } catch(e){ setRecords([]) }
    setPageLoad(false)
  }

  const loadDeleted = async (p) => {
    setPageLoad(true)
    try {
      const resp = await api.get("cc-spoiled-purchases-deleted?per_page=200&page=" + (p||1))
      const d = resp.data?.data
      setDeletedRecords(d?.data || arr(resp))
      setDelPage(d?.current_page || 1)
      setDelTotalPages(d?.last_page || 1)
    } catch(e){ setDeletedRecords([]) }
    setPageLoad(false)
  }

  // - cascading helpers -
  const fetchPlants = async (companyId, setter) => {
    try { setter(arr(await api.get("plants-by-company/" + companyId))) } catch(e){ setter([]) }
  }
  const fetchCCs = async (plantId, setter) => {
    try { setter(arr(await api.get("chillings-by-plant/" + plantId))) } catch(e){ setter([]) }
  }
  const fetchRoutes = async (ccId, setter) => {
    try { setter(arr(await api.get("route-cc/" + ccId))) } catch(e){ setter([]) }
  }
  const fetchVendors = async (ccId, setter) => {
    try { setter(arr(await api.get("vendors?chillingCenter=" + ccId + "&per_page=500"))) } catch(e){ setter([]) }
  }

  // - filtering -
  const filtered = useMemo(() => {
    let d = records
    if (searchTxt) {
      const s = searchTxt.toLowerCase()
      d = d.filter(r => (r.ccName||"").toLowerCase().includes(s) || (r.routeName||"").toLowerCase().includes(s) ||
        (r.vendorName||"").toLowerCase().includes(s) || (r.centerName||"").toLowerCase().includes(s) ||
        (r.spoiledDate||"").includes(s) || (r.reason||"").toLowerCase().includes(s))
    }
    if (fDate) d = d.filter(r => r.spoiledDate >= fDate)
    if (fDateTo) d = d.filter(r => r.spoiledDate <= fDateTo)
    if (fCC) d = d.filter(r => (r.ccName||"").toLowerCase().includes(fCC.toLowerCase()))
    if (fShift) d = d.filter(r => String(r.shift) === fShift)
    return d
  }, [records, searchTxt, fDate, fDateTo, fCC, fShift])

  // - select helpers -
  const allSelected = filtered.length > 0 && selected.length === filtered.length
  const toggleAll = () => setSelected(allSelected ? [] : filtered.map(r => r.id))
  const toggleOne = id => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id])

  // - delete helpers -
  const fetchDelete = async () => {
    try {
      await api.delete("delete-cc-spoiled-purchase/" + deleteId)
      loadData(page)
    } catch(e){}
  }

  const handleBulkDelete = async () => {
    if (!selected.length) return
    try {
      await api.post("bulk-delete-cc-spoiled-purchases", { ids: selected })
      setSelected([]); loadData(page)
      setDlgMsg(selected.length + " record(s) deleted."); setsuccess_dlg(true)
    } catch(e){}
  }

  const handleRestore = async (id) => {
    try {
      await api.put("restore-cc-spoiled-purchase/" + id)
      loadDeleted(delPage)
      setDlgMsg("Record restored."); setsuccess_dlg(true)
    } catch(e){}
  }

  // - row default for Add modal -
  const defaultRow = () => ({ routeNo:"", routeName:"", routeId:null, vendorNo:"", vendorName:"", vendorId:null, milkType:"3", qtyLtrs:"", purchaseFat:"", purchaseSnf:"", spoilRemarks:"", ratePerLtr:"", incentive:"", lookupR:"", lookupV:"" })

  // - icon button helper -
  const ib = (bg, icon, title, onClick, dis) => (
    <button title={title} onClick={onClick} disabled={dis}
      style={{ width:32, height:32, borderRadius:4, background:bg, color:"#fff", border:"none", display:"inline-flex", alignItems:"center", justifyContent:"center", fontSize:14, cursor:dis?"not-allowed":"pointer", opacity:dis?0.5:1 }}>
      <i className={`fas ${icon}`} />
    </button>
  )
  const milkLabel = t => t==1?"Cow":t==2?"Buffalo":"Common"
  const shiftLabel = s => s==0||s==="0"?"AM":"PM"

  // - Pagination Component -
  const Pager = ({ cur, total, onChange }) => (
    <div style={{ display:"flex", justifyContent:"flex-end", alignItems:"center", gap:4, marginTop:8 }}>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(1)} disabled={cur<=1}>-</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur-1)} disabled={cur<=1}>-</button>
      <span style={{ padding:"2px 10px", background:"#0d6efd", color:"#fff", borderRadius:4, fontSize:13 }}>{cur}</span>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(cur+1)} disabled={cur>=total}>-</button>
      <button className="btn btn-sm btn-outline-secondary" onClick={() => onChange(total)} disabled={cur>=total}>-</button>
    </div>
  )


  // - ADD MODAL HANDLERS -

  const openAdd = async () => {
    setAddPlant(""); setAddCC(""); setAddDate(new Date().toISOString().slice(0,10))
    setAddShift("0"); setAddQP(true); setAddCR(false); setAddCI(false)
    setAddPlants([]); setAddCCs([]); setAddShowTable(false); setAddRows([])
    setAddCompany("")
    if (multiCompany) { /* user picks company first */ }
    else if (companies.length === 1) {
      setAddCompany(companies[0].id)
      await fetchPlants(companies[0].id, setAddPlants)
    }
    setAddOpen(true)
  }

  const onAddCompany = async v => {
    setAddCompany(v); setAddPlant(""); setAddCC("")
    setAddPlants([]); setAddCCs([]); setAddShowTable(false); setAddRows([])
    if (v) await fetchPlants(v, setAddPlants)
  }
  const onAddPlant = async v => {
    setAddPlant(v); setAddCC(""); setAddCCs([]); setAddShowTable(false); setAddRows([])
    if (v) await fetchCCs(v, setAddCCs)
  }
  const onAddCC = v => { setAddCC(v); setAddShowTable(false); setAddRows([]) }

  const handleAddNew = () => {
    if (!addPlant || !addCC || !addDate) return alert("Please fill all required fields")
    setAddShowTable(true)
    if (addRows.length === 0) setAddRows([defaultRow()])
  }

  const setAddRowField = async (idx, field, val) => {
    const rows = [...addRows]
    rows[idx] = { ...rows[idx], [field]: val }

    // auto-lookup route
    if (field === "routeNo" && val) {
      try {
        const r = await api.get("lookup-route-by-number?number=" + val + "&chillingCenter=" + addCC)
        rows[idx].routeName = r.data?.data?.routeName || ""
        rows[idx].routeId = r.data?.data?.id || null
        rows[idx].lookupR = rows[idx].routeId ? "ok" : "err"
      } catch(e){ rows[idx].lookupR = "err"; rows[idx].routeName = "" }
    }
    // auto-lookup vendor
    if (field === "vendorNo" && val) {
      const routeId = rows[idx].routeId || ""
      try {
        const r = await api.get("lookup-vendor-by-number?number=" + val + "&chillingCenter=" + addCC + "&route=" + routeId)
        rows[idx].vendorName = r.data?.data?.vendorName || ""
        rows[idx].vendorId = r.data?.data?.id || null
        rows[idx].milkType = String(r.data?.data?.milkType ?? r.data?.data?.milkTypeCc ?? 3)
        rows[idx].lookupV = rows[idx].vendorId ? "ok" : "err"
      } catch(e){ rows[idx].lookupV = "err"; rows[idx].vendorName = "" }
    }
    setAddRows(rows)
  }

  const removeAddRow = idx => { const r = [...addRows]; r.splice(idx, 1); setAddRows(r) }

  const handleAddSave = async () => {
    const valid = addRows.filter(r => parseFloat(r.qtyLtrs) > 0)
    if (!valid.length) return alert("Add at least one row with quantity")
    setAddSaving(true)
    try {
      const payload = {
        chillingCenter: parseInt(addCC),
        spoiledDate: addDate,
        shift: parseInt(addShift),
        qualityParams: addQP,
        customRate: addCR,
        customIncentive: addCI,
        rows: valid.map(r => ({
          route: r.routeId || null,
          vendor: r.vendorId || null,
          milkType: parseInt(r.milkType || 3),
          qtyLtrs: parseFloat(r.qtyLtrs || 0),
          purchaseFat: parseFloat(r.purchaseFat || 0),
          purchaseSnf: parseFloat(r.purchaseSnf || 0),
          spoilRemarks: r.spoilRemarks || "",
          ratePerLtr: parseFloat(r.ratePerLtr || 0),
          incentive: parseFloat(r.incentive || 0),
        }))
      }
      const resp = await api.post("bulk-create-cc-spoiled-purchases", payload)
      if (resp.data?.success) {
        setAddOpen(false); loadData(1)
        setDlgMsg(resp.data.message || "Saved!"); setsuccess_dlg(true)
      } else { alert(resp.data?.data || "Save failed") }
    } catch(e) { alert("Error: " + (e.response?.data?.data || e.message)) }
    setAddSaving(false)
  }

  // - ADD MODAL JSX -
  const addModalJSX = (
    <Modal isOpen={addOpen} toggle={() => setAddOpen(false)} size="xl" backdrop="static">
      <div style={{ padding:"20px 24px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <h5 style={{ margin:0 }}>CC Spoiled Purchase Entry <span style={{ color:"red", fontSize:13 }}>[* required]</span></h5>
          <button className="btn-close" onClick={() => setAddOpen(false)} />
        </div>

        {/* Row 1: Company + Plant + CC + Date + Shift */}
        <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginBottom:12 }}>
          {multiCompany && (
            <div style={{ flex:"1 1 180px" }}>
              <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Company *</label>
              <select className="form-control form-control-sm" value={addCompany} onChange={e => onAddCompany(e.target.value)}>
                <option value="">Select</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex:"1 1 180px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Plant *</label>
            <select className="form-control form-control-sm" value={addPlant} onChange={e => onAddPlant(e.target.value)}>
              <option value="">Select</option>
              {addPlants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div style={{ flex:"1 1 180px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Chilling Center *</label>
            <select className="form-control form-control-sm" value={addCC} onChange={e => onAddCC(e.target.value)}>
              <option value="">Select</option>
              {addCCs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div style={{ flex:"1 1 140px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Date *</label>
            <input type="date" className="form-control form-control-sm" value={addDate} onChange={e => setAddDate(e.target.value)} />
          </div>
          <div style={{ flex:"0 0 100px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Shift *</label>
            <div style={{ display:"flex", gap:12, paddingTop:4 }}>
              <label><input type="radio" name="addShift" checked={addShift==="0"} onChange={() => setAddShift("0")} /> AM</label>
              <label><input type="radio" name="addShift" checked={addShift==="1"} onChange={() => setAddShift("1")} /> PM</label>
            </div>
          </div>
        </div>

        {/* Row 2: Quality Params + Custom Rate + Custom Incentive */}
        <div style={{ display:"flex", gap:32, flexWrap:"wrap", marginBottom:16 }}>
          <div>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Quality Parameters Entry *</label>
            <div style={{ display:"flex", gap:12 }}>
              <label><input type="radio" checked={addQP} onChange={() => setAddQP(true)} /> Yes</label>
              <label><input type="radio" checked={!addQP} onChange={() => setAddQP(false)} /> No</label>
            </div>
          </div>
          <div>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Custom Rate *</label>
            <div style={{ display:"flex", gap:12 }}>
              <label><input type="radio" checked={addCR} onChange={() => setAddCR(true)} /> Yes</label>
              <label><input type="radio" checked={!addCR} onChange={() => setAddCR(false)} /> No</label>
            </div>
          </div>
          <div>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Custom Incentive *</label>
            <div style={{ display:"flex", gap:12 }}>
              <label><input type="radio" checked={addCI} onChange={() => setAddCI(true)} /> Yes</label>
              <label><input type="radio" checked={!addCI} onChange={() => setAddCI(false)} /> No</label>
            </div>
          </div>
        </div>

        {/* Add New button */}
        <button className="btn btn-info btn-sm" style={{ fontWeight:700, marginBottom:12 }} onClick={handleAddNew}>Add New</button>

        {/* Entry Table */}
        {addShowTable && (
          <div style={{ maxHeight:320, overflowY:"auto", overflowX:"auto", border:"1px solid #dee2e6", borderRadius:6 }}>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize:12, minWidth: addQP ? 1100 : 700 }}>
              <thead style={{ background:"#f8f9fa", position:"sticky", top:0, zIndex:1 }}>
                <tr>
                  <th style={{ width:28 }}>#</th>
                  <th>Route No</th><th>Route Name</th>
                  <th>Vendor No</th><th>Vendor Name</th>
                  <th>Milk</th><th>Qty</th>
                  {addQP && <><th>FAT</th><th>SNF</th></>}
                  <th>Spoil Remarks</th>
                  {addQP && addCR && <th>Rate</th>}
                  {addQP && addCI && <th>Inc.</th>}
                  <th style={{ width:28 }}>X</th>
                </tr>
              </thead>
              <tbody>
                {addRows.map((r, i) => (
                  <tr key={i}>
                    <td style={{ textAlign:"center" }}>{i+1}</td>
                    <td><input className="form-control form-control-sm" value={r.routeNo} onChange={e => { const rows=[...addRows]; rows[i]={...rows[i], routeNo:e.target.value, lookupR:""}; setAddRows(rows) }} onBlur={e => { if(e.target.value) setAddRowField(i,"routeNo",e.target.value) }} style={{ width:70, borderColor: r.lookupR==="err"?"#dc3545":r.lookupR==="ok"?"#198754":"" }} /></td>
                    <td style={{ color: r.lookupR==="ok"?"#198754":r.lookupR==="err"?"#dc3545":"#999", whiteSpace:"nowrap", fontSize:11, fontWeight: r.lookupR ? 600 : 400 }}>{r.lookupR==="err" ? "Not Found" : r.routeName || "-"}</td>
                    <td><input className="form-control form-control-sm" value={r.vendorNo} onChange={e => { const rows=[...addRows]; rows[i]={...rows[i], vendorNo:e.target.value, lookupV:""}; setAddRows(rows) }} onBlur={e => { if(e.target.value) setAddRowField(i,"vendorNo",e.target.value) }} style={{ width:70, borderColor: r.lookupV==="err"?"#dc3545":r.lookupV==="ok"?"#198754":"" }} /></td>
                    <td style={{ color: r.lookupV==="ok"?"#198754":r.lookupV==="err"?"#dc3545":"#999", whiteSpace:"nowrap", fontSize:11, fontWeight: r.lookupV ? 600 : 400 }}>{r.lookupV==="err" ? "Not Found" : r.vendorName || "-"}</td>
                    <td>
                      <select className="form-control form-control-sm" style={{ width:70 }} value={r.milkType} onChange={e => { const rows=[...addRows]; rows[i].milkType=e.target.value; setAddRows(rows) }}>
                        <option value="1">Cow</option><option value="2">Buf</option><option value="3">Cmn</option>
                      </select>
                    </td>
                    <td><input type="number" className="form-control form-control-sm" style={{ width:70 }} value={r.qtyLtrs} onChange={e => { const rows=[...addRows]; rows[i].qtyLtrs=e.target.value; setAddRows(rows) }} /></td>
                    {addQP && <td><input type="number" step="0.1" className="form-control form-control-sm" style={{ width:60 }} value={r.purchaseFat} onChange={e => { const rows=[...addRows]; rows[i].purchaseFat=e.target.value; setAddRows(rows) }} /></td>}
                    {addQP && <td><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:60 }} value={r.purchaseSnf} onChange={e => { const rows=[...addRows]; rows[i].purchaseSnf=e.target.value; setAddRows(rows) }} /></td>}
                    <td><input className="form-control form-control-sm" style={{ width:120 }} value={r.spoilRemarks} onChange={e => { const rows=[...addRows]; rows[i].spoilRemarks=e.target.value; setAddRows(rows) }} /></td>
                    {addQP && addCR && <td><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:70 }} value={r.ratePerLtr} onChange={e => { const rows=[...addRows]; rows[i].ratePerLtr=e.target.value; setAddRows(rows) }} /></td>}
                    {addQP && addCI && <td><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:60 }} value={r.incentive} onChange={e => { const rows=[...addRows]; rows[i].incentive=e.target.value; setAddRows(rows) }} /></td>}
                    <td style={{ textAlign:"center" }}><button className="btn btn-sm btn-outline-danger" style={{ padding:"0 5px" }} onClick={() => removeAddRow(i)}>-</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {addShowTable && <button className="btn btn-sm btn-outline-primary mt-2" onClick={() => setAddRows([...addRows, defaultRow()])}>+ Add Row</button>}

        {/* Footer */}
        <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:16 }}>
          <button className="btn btn-success btn-sm" style={{ fontWeight:700 }} onClick={handleAddSave} disabled={addSaving}>{addSaving ? "Saving..." : "Save Changes"}</button>
          <button className="btn btn-danger btn-sm" onClick={() => setAddOpen(false)}>Close</button>
        </div>
      </div>
    </Modal>
  )


  // - EDIT MODAL HANDLERS -

  const openEdit = async (id) => {
    setEditId(id); setEditLoading(true); setEditOpen(true)
    setEditPlants([]); setEditCCs([]); setEditRoutes([]); setEditVendors([])
    try {
      const resp = await api.get("cc-spoiled-purchase/" + id)
      const rec = resp.data?.data
      if (!rec) { alert("Record not found"); setEditOpen(false); return }
      setEditData({
        chillingCenter: rec.chillingCenter || "",
        route: rec.route || "",
        vendor: rec.vendor || "",
        collectionCenter: rec.collectionCenter || "",
        spoiledDate: rec.spoiledDate || "",
        shift: String(rec.shift ?? "0"),
        milkType: String(rec.milkType ?? "3"),
        qtyLtrs: rec.qtyLtrs || "",
        qtyKg: rec.qtyKg || "",
        purchaseFat: rec.purchaseFat || "",
        purchaseSnf: rec.purchaseSnf || "",
        purchaseClr: rec.purchaseClr || "",
        ratePerLtr: rec.ratePerLtr || "",
        estimatedLoss: rec.estimatedLoss || "",
        reason: rec.reason || "",
        reasonDetails: rec.reasonDetails || "",
        actionTaken: rec.actionTaken || "",
        reportedBy: rec.reportedBy || "",
        plantId: rec.plantId || "",
        companyId: rec.companyId || "",
        ccName: rec.ccName || "",
        routeName: rec.routeName || "",
        vendorName: rec.vendorName || "",
      })
      // Load cascading data
      if (rec.companyId) {
        const plants = arr(await api.get("plants-by-company/" + rec.companyId))
        setEditPlants(plants)
      }
      if (rec.plantId) {
        const ccs = arr(await api.get("chillings-by-plant/" + rec.plantId))
        setEditCCs(ccs)
      }
      if (rec.chillingCenter) {
        const routes = arr(await api.get("route-cc/" + rec.chillingCenter))
        setEditRoutes(routes)
      }
    } catch(e){ alert("Error loading record"); setEditOpen(false) }
    setEditLoading(false)
  }

  const setEditField = (f, v) => setEditData(prev => ({ ...prev, [f]: v }))

  const onEditPlant = async v => {
    setEditField("plantId", v); setEditField("chillingCenter", "")
    setEditCCs([]); setEditRoutes([])
    if (v) await fetchCCs(v, setEditCCs)
  }
  const onEditCC = async v => {
    setEditField("chillingCenter", v); setEditField("route", "")
    setEditRoutes([])
    if (v) await fetchRoutes(v, setEditRoutes)
  }

  const handleEditSave = async () => {
    if (!editData.chillingCenter || !editData.spoiledDate || !editData.qtyLtrs) return alert("Fill required fields")
    setEditSaving(true)
    try {
      const resp = await api.put("update-cc-spoiled-purchase/" + editId, editData)
      if (resp.data?.success) {
        setEditOpen(false); loadData(page)
        setDlgMsg("Spoiled purchase updated."); setsuccess_dlg(true)
      } else { alert(resp.data?.data || "Update failed") }
    } catch(e){ alert("Error: " + (e.response?.data?.data || e.message)) }
    setEditSaving(false)
  }

  // - EDIT MODAL JSX -
  const editModalJSX = (
    <Modal isOpen={editOpen} toggle={() => setEditOpen(false)} size="lg" backdrop="static">
      <div style={{ padding:"20px 24px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <h5 style={{ margin:0 }}>Edit CC Spoiled Purchase <span style={{ color:"red", fontSize:13 }}>[* required]</span></h5>
          <button className="btn-close" onClick={() => setEditOpen(false)} />
        </div>

        {editLoading ? <div style={{ textAlign:"center", padding:40 }}><img src={PageLoader} alt="Loading..." style={{ width:50 }} /></div> : (
          <>
            {/* Location */}
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
              <div style={{ flex:"1 1 180px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Plant *</label>
                <select className="form-control form-control-sm" value={editData.plantId} onChange={e => onEditPlant(e.target.value)}>
                  <option value="">Select</option>
                  {editPlants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
              </div>
              <div style={{ flex:"1 1 180px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Chilling Center *</label>
                <select className="form-control form-control-sm" value={editData.chillingCenter} onChange={e => onEditCC(e.target.value)}>
                  <option value="">Select</option>
                  {editCCs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div style={{ flex:"1 1 160px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Route</label>
                <select className="form-control form-control-sm" value={editData.route} onChange={e => setEditField("route", e.target.value)}>
                  <option value="">Select</option>
                  {editRoutes.map(r => <option key={r.id} value={r.id}>{r.routeName}</option>)}
                </select>
              </div>
            </div>

            {/* Details */}
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
              <div style={{ flex:"1 1 140px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Date *</label>
                <input type="date" className="form-control form-control-sm" value={editData.spoiledDate} onChange={e => setEditField("spoiledDate", e.target.value)} />
              </div>
              <div style={{ flex:"0 0 120px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Shift *</label>
                <div style={{ display:"flex", gap:12, paddingTop:4 }}>
                  <label><input type="radio" checked={editData.shift==="0"} onChange={() => setEditField("shift","0")} /> AM</label>
                  <label><input type="radio" checked={editData.shift==="1"} onChange={() => setEditField("shift","1")} /> PM</label>
                </div>
              </div>
              <div style={{ flex:"0 0 160px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Milk Type *</label>
                <select className="form-control form-control-sm" value={editData.milkType} onChange={e => setEditField("milkType", e.target.value)}>
                  <option value="1">Cow</option><option value="2">Buffalo</option><option value="3">Common</option>
                </select>
              </div>
            </div>

            {/* Quantity & Quality */}
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
              <div style={{ flex:"1 1 100px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Qty (Ltrs) *</label>
                <input type="number" step="0.01" className="form-control form-control-sm" value={editData.qtyLtrs} onChange={e => setEditField("qtyLtrs", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 100px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Qty (KG)</label>
                <input type="number" step="0.01" className="form-control form-control-sm" value={editData.qtyKg} onChange={e => setEditField("qtyKg", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 80px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>FAT</label>
                <input type="number" step="0.1" className="form-control form-control-sm" value={editData.purchaseFat} onChange={e => setEditField("purchaseFat", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 80px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>SNF</label>
                <input type="number" step="0.01" className="form-control form-control-sm" value={editData.purchaseSnf} onChange={e => setEditField("purchaseSnf", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 80px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Rate/Ltr</label>
                <input type="number" step="0.01" className="form-control form-control-sm" value={editData.ratePerLtr} onChange={e => setEditField("ratePerLtr", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 80px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Est. Loss</label>
                <input type="number" step="0.01" className="form-control form-control-sm" value={editData.estimatedLoss} onChange={e => setEditField("estimatedLoss", e.target.value)} />
              </div>
            </div>

            {/* Spoil info */}
            <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
              <div style={{ flex:"1 1 200px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Spoil Remarks</label>
                <input className="form-control form-control-sm" value={editData.reason} onChange={e => setEditField("reason", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 200px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Details</label>
                <input className="form-control form-control-sm" value={editData.reasonDetails} onChange={e => setEditField("reasonDetails", e.target.value)} />
              </div>
              <div style={{ flex:"1 1 140px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Reported By</label>
                <input className="form-control form-control-sm" value={editData.reportedBy} onChange={e => setEditField("reportedBy", e.target.value)} />
              </div>
            </div>

            {/* Footer */}
            <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:16 }}>
              <button className="btn btn-success btn-sm" style={{ fontWeight:700 }} onClick={handleEditSave} disabled={editSaving}>{editSaving ? "Saving..." : "Save Changes"}</button>
              <button className="btn btn-danger btn-sm" onClick={() => setEditOpen(false)}>Close</button>
            </div>
          </>
        )}
      </div>
    </Modal>
  )


  // - UPDATE MODAL HANDLERS -

  const openUpdate = async () => {
    setUpPlant(""); setUpCC(""); setUpRoute(""); setUpVendor("")
    setUpDate(new Date().toISOString().slice(0,10)); setUpShift("0")
    setUpDisplay("single"); setUpCR(true); setUpPeriodFrom(""); setUpPeriodTo("")
    setUpPlants([]); setUpCCs([]); setUpRoutes([]); setUpVendors([])
    setUpPreviewRows([]); setUpOrigRows([]); setUpCompany("")
    if (multiCompany) { /* user picks */ }
    else if (companies.length === 1) {
      setUpCompany(companies[0].id)
      await fetchPlants(companies[0].id, setUpPlants)
    }
    setUpOpen(true)
  }

  const onUpCompany = async v => {
    setUpCompany(v); setUpPlant(""); setUpCC(""); setUpRoute(""); setUpVendor("")
    setUpPlants([]); setUpCCs([]); setUpRoutes([]); setUpVendors([])
    setUpPreviewRows([]); setUpOrigRows([])
    if (v) await fetchPlants(v, setUpPlants)
  }
  const onUpPlant = async v => {
    setUpPlant(v); setUpCC(""); setUpRoute(""); setUpVendor("")
    setUpCCs([]); setUpRoutes([]); setUpVendors([])
    setUpPreviewRows([]); setUpOrigRows([])
    if (v) await fetchCCs(v, setUpCCs)
  }
  const onUpCC = async v => {
    setUpCC(v); setUpRoute(""); setUpVendor("")
    setUpRoutes([]); setUpVendors([])
    setUpPreviewRows([]); setUpOrigRows([])
    if (v) { await fetchRoutes(v, setUpRoutes); await fetchVendors(v, setUpVendors) }
  }

  const handleUpPreview = async () => {
    if (!upCC) return alert("Select Chilling Center")
    setUpLoading(true)
    try {
      const payload = {
        chillingCenter: upCC,
        route: upRoute || undefined,
        vendor: upVendor || undefined,
        display: upDisplay,
        spoiledDate: upDisplay === "single" ? upDate : undefined,
        shift: upDisplay === "single" ? upShift : undefined,
        periodFrom: upDisplay === "period" ? upPeriodFrom : undefined,
        periodTo: upDisplay === "period" ? upPeriodTo : undefined,
      }
      const resp = await api.post("cc-spoiled-purchase-update-preview", payload)
      const rows = resp.data?.data || []
      setUpOrigRows(JSON.parse(JSON.stringify(rows)))
      setUpPreviewRows(rows.map(r => ({ ...r })))
    } catch(e){ setUpPreviewRows([]); setUpOrigRows([]) }
    setUpLoading(false)
  }

  const setUpRowField = (idx, field, val) => {
    const rows = [...upPreviewRows]
    rows[idx] = { ...rows[idx], [field]: val }
    // Recalculate amounts
    if (["newQty","newRate"].includes(field)) {
      rows[idx].newAmount = ((parseFloat(rows[idx].newQty)||0) * (parseFloat(rows[idx].newRate)||0)).toFixed(2)
    }
    setUpPreviewRows(rows)
  }

  const handleUpSave = async () => {
    if (!upPreviewRows.length) return alert("No records to update")
    setUpSaving(true)
    try {
      const rows = upPreviewRows.map(r => ({
        id: r.id,
        qtyLtrs: r.newQty,
        purchaseFat: r.newFat,
        purchaseSnf: r.newSnf,
        ratePerLtr: r.newRate,
        estimatedLoss: r.newAmount,
        reason: r.reason,
      }))
      const resp = await api.post("bulk-update-cc-spoiled-purchases", { rows })
      if (resp.data?.success) {
        setUpOpen(false); loadData(page)
        setDlgMsg(resp.data.message || "Updated!"); setsuccess_dlg(true)
      } else { alert(resp.data?.data || "Update failed") }
    } catch(e){ alert("Error: " + (e.response?.data?.data || e.message)) }
    setUpSaving(false)
  }

  // yellow header style for "New" columns
  const yh = { background:"#f59e0b", color:"#fff", fontWeight:700, fontSize:11 }
  const gh = { background:"#f1f3f5", fontWeight:700, fontSize:11 }

  // - UPDATE MODAL JSX -
  const updateModalJSX = (
    <Modal isOpen={upOpen} toggle={() => setUpOpen(false)} size="xl" backdrop="static">
      <div style={{ padding:"20px 24px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <h5 style={{ margin:0 }}>CC Spoiled Purchases Update <span style={{ color:"red", fontSize:13 }}>[* required]</span></h5>
          <button className="btn-close" onClick={() => setUpOpen(false)} />
        </div>

        {/* Row 1: Company + Plant + CC + Route + Vendor */}
        <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
          {multiCompany && (
            <div style={{ flex:"1 1 160px" }}>
              <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Company *</label>
              <select className="form-control form-control-sm" value={upCompany} onChange={e => onUpCompany(e.target.value)}>
                <option value="">Select</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
          )}
          <div style={{ flex:"1 1 160px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Plant *</label>
            <select className="form-control form-control-sm" value={upPlant} onChange={e => onUpPlant(e.target.value)}>
              <option value="">Select</option>
              {upPlants.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div style={{ flex:"1 1 160px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Chilling Center *</label>
            <select className="form-control form-control-sm" value={upCC} onChange={e => onUpCC(e.target.value)}>
              <option value="">Select</option>
              {upCCs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div style={{ flex:"1 1 160px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Route</label>
            <select className="form-control form-control-sm" value={upRoute} onChange={e => setUpRoute(e.target.value)}>
              <option value="">All</option>
              {upRoutes.map(r => <option key={r.id} value={r.id}>{r.routeNumber} {r.routeName}</option>)}
            </select>
          </div>
          <div style={{ flex:"1 1 160px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Center/Vendor</label>
            <select className="form-control form-control-sm" value={upVendor} onChange={e => setUpVendor(e.target.value)}>
              <option value="">All</option>
              {upVendors.map(v => <option key={v.id} value={v.id}>{v.vendorName||v.name}</option>)}
            </select>
          </div>
        </div>

        {/* Row 2: Display + Date + Shift + Custom Rate */}
        <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginBottom:12 }}>
          <div style={{ flex:"0 0 160px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Display *</label>
            <div style={{ display:"flex", gap:12, paddingTop:4 }}>
              <label><input type="radio" checked={upDisplay==="period"} onChange={() => setUpDisplay("period")} /> Period</label>
              <label><input type="radio" checked={upDisplay==="single"} onChange={() => setUpDisplay("single")} /> Single Shift</label>
            </div>
          </div>
          {upDisplay === "single" ? (
            <>
              <div style={{ flex:"1 1 140px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Date *</label>
                <input type="date" className="form-control form-control-sm" value={upDate} onChange={e => setUpDate(e.target.value)} />
              </div>
              <div style={{ flex:"0 0 100px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Shift *</label>
                <div style={{ display:"flex", gap:12, paddingTop:4 }}>
                  <label><input type="radio" checked={upShift==="0"} onChange={() => setUpShift("0")} /> AM</label>
                  <label><input type="radio" checked={upShift==="1"} onChange={() => setUpShift("1")} /> PM</label>
                </div>
              </div>
            </>
          ) : (
            <>
              <div style={{ flex:"1 1 130px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>From *</label>
                <input type="date" className="form-control form-control-sm" value={upPeriodFrom} onChange={e => setUpPeriodFrom(e.target.value)} />
              </div>
              <div style={{ flex:"1 1 130px" }}>
                <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>To *</label>
                <input type="date" className="form-control form-control-sm" value={upPeriodTo} onChange={e => setUpPeriodTo(e.target.value)} />
              </div>
            </>
          )}
          <div style={{ flex:"0 0 120px" }}>
            <label className="form-label" style={{ fontWeight:700, fontSize:13 }}>Custom Rate *</label>
            <div style={{ display:"flex", gap:12, paddingTop:4 }}>
              <label><input type="radio" checked={upCR} onChange={() => setUpCR(true)} /> Yes</label>
              <label><input type="radio" checked={!upCR} onChange={() => setUpCR(false)} /> No</label>
            </div>
          </div>
        </div>

        {/* Preview button */}
        <button className="btn btn-primary btn-sm" style={{ fontWeight:700, marginBottom:8 }} onClick={handleUpPreview} disabled={upLoading}>
          {upLoading ? "Loading..." : "Preview"}
        </button>
        <div style={{ color:"#0d6efd", fontWeight:700, fontSize:13, marginBottom:8 }}>Total Entries : {upPreviewRows.length}</div>

        {/* Preview Table */}
        {upPreviewRows.length > 0 && (
          <div style={{ maxHeight:320, overflowY:"auto", overflowX:"auto", border:"1px solid #dee2e6", borderRadius:6 }}>
            <table className="table table-sm table-bordered mb-0" style={{ fontSize:11, minWidth:1400 }}>
              <thead style={{ position:"sticky", top:0, zIndex:1 }}>
                <tr>
                  <th style={gh}>#</th>
                  <th style={gh}>Route</th><th style={gh}>Member</th>
                  <th style={gh}>Date</th><th style={gh}>Shift</th><th style={gh}>Milk</th>
                  <th style={gh}>Old Qty</th><th style={yh}>New Qty</th>
                  <th style={gh}>Old FAT</th><th style={yh}>New FAT</th>
                  <th style={gh}>Old SNF</th><th style={yh}>New SNF</th>
                  <th style={gh}>Old Rate</th><th style={yh}>New Rate</th>
                  <th style={gh}>Old Inc</th><th style={yh}>New Inc</th>
                  <th style={gh}>Old Amount</th><th style={gh}>New Amount</th>
                  <th style={gh}>Spoilage Remarks</th>
                </tr>
              </thead>
              <tbody>
                {upPreviewRows.map((r, i) => (
                  <tr key={r.id || i}>
                    <td>{i+1}</td>
                    <td style={{ whiteSpace:"nowrap" }}>{r.routeName || "-"}</td>
                    <td style={{ whiteSpace:"nowrap" }}>{r.vendorName || "-"}</td>
                    <td style={{ whiteSpace:"nowrap" }}>{r.spoiledDate}</td>
                    <td>{shiftLabel(r.shift)}</td>
                    <td>{milkLabel(r.milkType)}</td>
                    <td>{r.qtyLtrs}</td>
                    <td style={{ background:"#fff8e1" }}><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:65 }} value={r.newQty} onChange={e => setUpRowField(i,"newQty",e.target.value)} /></td>
                    <td>{r.purchaseFat}</td>
                    <td style={{ background:"#fff8e1" }}><input type="number" step="0.1" className="form-control form-control-sm" style={{ width:55 }} value={r.newFat} onChange={e => setUpRowField(i,"newFat",e.target.value)} /></td>
                    <td>{r.purchaseSnf}</td>
                    <td style={{ background:"#fff8e1" }}><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:55 }} value={r.newSnf} onChange={e => setUpRowField(i,"newSnf",e.target.value)} /></td>
                    <td>{r.ratePerLtr}</td>
                    <td style={{ background:"#fff8e1" }}><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:60 }} value={r.newRate} onChange={e => setUpRowField(i,"newRate",e.target.value)} /></td>
                    <td>{r.incentive||0}</td>
                    <td style={{ background:"#fff8e1" }}><input type="number" step="0.01" className="form-control form-control-sm" style={{ width:55 }} value={r.newIncentive} onChange={e => setUpRowField(i,"newIncentive",e.target.value)} /></td>
                    <td>{r.estimatedLoss}</td>
                    <td style={{ fontWeight:700 }}>{r.newAmount}</td>
                    <td><input className="form-control form-control-sm" style={{ width:100 }} value={r.reason} onChange={e => setUpRowField(i,"reason",e.target.value)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Footer */}
        <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:16 }}>
          <button className="btn btn-success btn-sm" style={{ fontWeight:700 }} onClick={handleUpSave} disabled={upSaving || !upPreviewRows.length}>{upSaving ? "Saving..." : "Save Changes"}</button>
          <button className="btn btn-danger btn-sm" onClick={() => setUpOpen(false)}>Close</button>
        </div>
      </div>
    </Modal>
  )


  // - MAIN RENDER -
  return (
    <>

      {/* - Unified Header: Tabs + Icons + Search - */}
      <div style={{
        display:"flex", alignItems:"center", flexWrap:"wrap", gap:"6px",
        marginBottom:"10px", background:"#f8f9fa",
        borderRadius:"8px", padding:"4px 8px", border:"1px solid #dee2e6",
      }}>
        {/* Tabs */}
        {[
          { id:"active", label:"CC Spoiled Purchases", icon:"fa-exclamation-triangle" },
          { id:"deleted", label:"Deleted CC Spoiled Purchases", icon:"fa-trash-alt" },
        ].map(t => (
          <button key={t.id}
            onClick={() => { setActiveTab(t.id); if(t.id==="active") loadData(1); else loadDeleted(1) }}
            style={{
              display:"flex", alignItems:"center", gap:"5px",
              padding:"5px 12px", border:"none", borderRadius:"6px", cursor:"pointer",
              fontWeight:600, fontSize:"13px", whiteSpace:"nowrap",
              background: activeTab===t.id ? "#0d6efd" : "transparent",
              color: activeTab===t.id ? "#fff" : "#495057",
              transition:"background 0.15s, color 0.15s",
            }}>
            <i className={`fas ${t.icon}`} style={{ fontSize:"12px" }} />
            {t.label}
          </button>
        ))}

        {/* Divider */}
        <div style={{ width:1, height:24, background:"#dee2e6", margin:"0 2px" }} />

        {/* Action Icons - Active tab */}
        {activeTab === "active" && (<>
          {canDelete(MID) && ib("#dc3545", "fa-trash-alt", "Delete Selected", () => { if(selected.length) setconfirm_alert(true); else alert("Select records first") }, !selected.length)}
          {canAdd(MID) && ib("#28a745", "fa-plus-square", "Add Spoiled Purchase", openAdd, false)}
          {canEdit(MID) && ib("#f59e0b", "fa-sync-alt", "Update Spoiled Purchases", openUpdate, false)}
          {ib("#0d6efd", "fa-filter", "Toggle Filter", () => { setShowFilter(!showFilter); if(showFilter){ setFDate(""); setFDateTo(""); setFCC(""); setFShift("") } }, false)}
        </>)}

        {/* Action Icons - Deleted tab */}
        {activeTab === "deleted" && (
          ib("#0d6efd", "fa-filter", "Toggle Filter", () => setShowFilter(!showFilter), false)
        )}

        {/* Spacer */}
        <div style={{ flex:1 }} />

        {/* Search */}
        <div style={{ display:"flex", gap:4 }}>
          <input className="form-control form-control-sm" style={{ width:180, fontSize:13 }} placeholder="Search" value={searchTxt} onChange={e => setSearchTxt(e.target.value)} />
          <button className="btn btn-sm btn-primary" style={{ padding:"2px 8px" }}><i className="fas fa-search" /></button>
        </div>
      </div>

      {pageLoad ? <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div> : (<>

      {/* - Active Tab Content - */}
      {activeTab === "active" && (
        <div style={{ overflowX:"auto" }}>
          <table className="table table-sm table-bordered table-hover mb-0 dairyTbl" style={{ fontSize:12 }}>
            <thead style={{ background:"#f8f9fa" }}>
              <tr>
                <th style={{ width:28 }}><input type="checkbox" checked={allSelected} onChange={toggleAll} /></th>
                <th>#</th>
                <th>Chilling Center</th><th>Route</th><th>Center</th>
                <th>Date</th><th>Shift</th><th>Serial</th><th>Milk Type</th>
                <th>Qty (Ltrs)</th><th>Qty (KG)</th>
                <th>FAT</th><th>SNF</th>
                <th>Rate Per Ltr</th><th>Rate Per KG</th>
                <th>Inc</th><th>Spoil Remarks</th><th>Action</th>
              </tr>
              {showFilter && (
                <tr style={{ background:"#f1f3f5" }}>
                  <td></td><td></td>
                  <td><input className="form-control form-control-sm" placeholder="CC" value={fCC} onChange={e => setFCC(e.target.value)} /></td>
                  <td></td><td></td>
                  <td><input type="date" className="form-control form-control-sm" value={fDate} onChange={e => setFDate(e.target.value)} /><input type="date" className="form-control form-control-sm mt-1" value={fDateTo} onChange={e => setFDateTo(e.target.value)} /></td>
                  <td><select className="form-control form-control-sm" value={fShift} onChange={e => setFShift(e.target.value)}><option value="">All</option><option value="0">AM</option><option value="1">PM</option></select></td>
                  <td colSpan={10}></td>
                  <td><button className="btn btn-sm btn-outline-danger" onClick={() => { setFDate(""); setFDateTo(""); setFCC(""); setFShift("") }}><i className="fa fa-times" /></button></td>
                </tr>
              )}
            </thead>
            <tbody>
              {filtered.length > 0 ? filtered.map((r, i) => (
                <tr key={r.id || i}>
                  <td><input type="checkbox" checked={selected.includes(r.id)} onChange={() => toggleOne(r.id)} /></td>
                  <td>{i+1}</td>
                  <td>{r.ccName || r.chillingCenter}</td>
                  <td>{r.routeName || "-"}</td>
                  <td>{r.centerName || r.vendorName || "-"}</td>
                  <td style={{ whiteSpace:"nowrap", fontSize:11 }}>{r.spoiledDate}</td>
                  <td><span className={`badge bg-${r.shift==0?"info":"warning"}`}>{shiftLabel(r.shift)}</span></td>
                  <td>{r.id}</td>
                  <td><span className={`badge bg-${r.milkType==1?"primary":r.milkType==2?"success":"secondary"}`}>{milkLabel(r.milkType)}</span></td>
                  <td><strong>{r.qtyLtrs}</strong></td>
                  <td>{r.qtyKg || "-"}</td>
                  <td style={{ fontWeight:600, color:"#d97706" }}>{r.purchaseFat || "-"}</td>
                  <td style={{ fontWeight:600, color:"#0284c7" }}>{r.purchaseSnf || "-"}</td>
                  <td>{r.ratePerLtr || "-"}</td>
                  <td>{r.qtyKg && r.ratePerLtr ? (parseFloat(r.ratePerLtr) * parseFloat(r.qtyLtrs) / parseFloat(r.qtyKg)).toFixed(2) : "-"}</td>
                  <td>{r.estimatedLoss || "0"}</td>
                  <td style={{ fontSize:11 }}>{r.reason || "-"}</td>
                  <td style={{ whiteSpace:"nowrap" }}>
                    {canEdit(MID) && <i className="fas fa-edit icons icon-edit" style={{ cursor:"pointer", color:"#0d6efd" }} onClick={() => openEdit(r.id)} />}
                    {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete" style={{ cursor:"pointer", color:"#dc3545", marginLeft:8 }} onClick={() => { setDeleteId(r.id); setconfirm_alert(true) }} />}
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={18}><center style={{ padding:20, color:"#6c757d" }}>No matching records found</center></td></tr>
              )}
            </tbody>
          </table>
          <Pager cur={page} total={totalPages} onChange={p => loadData(p)} />
        </div>
      )}

      {/* - Deleted Tab Content - */}
      {activeTab === "deleted" && (
        <div style={{ overflowX:"auto" }}>
          <table className="table table-sm table-bordered table-hover mb-0 dairyTbl" style={{ fontSize:12 }}>
            <thead style={{ background:"#f8f9fa" }}>
              <tr>
                <th>#</th><th>CC Name</th><th>Date</th><th>Shift</th><th>Serial</th>
                <th>Milk</th><th>Qty (ltrs)</th><th>Qty (KG)</th>
                <th>Rate Per Liter</th><th>Rate Per KG</th>
                <th>Deleted By</th><th>Deleted At</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {deletedRecords.length > 0 ? deletedRecords.map((r, i) => (
                <tr key={r.id || i}>
                  <td>{i+1}</td>
                  <td>{r.ccName || r.chillingCenter}</td>
                  <td style={{ whiteSpace:"nowrap", fontSize:11 }}>{r.spoiledDate}</td>
                  <td><span className={`badge bg-${r.shift==0?"info":"warning"}`}>{shiftLabel(r.shift)}</span></td>
                  <td>{r.id}</td>
                  <td>{milkLabel(r.milkType)}</td>
                  <td><strong>{r.qtyLtrs}</strong></td>
                  <td>{r.qtyKg || "-"}</td>
                  <td>{r.ratePerLtr || "-"}</td>
                  <td>{r.qtyKg && r.ratePerLtr ? (parseFloat(r.ratePerLtr) * parseFloat(r.qtyLtrs) / parseFloat(r.qtyKg || 1)).toFixed(2) : "-"}</td>
                  <td>{r.reportedBy || "-"}</td>
                  <td style={{ whiteSpace:"nowrap", fontSize:11 }}>{r.deleted_at ? new Date(r.deleted_at).toLocaleString() : "-"}</td>
                  <td><button className="btn btn-sm btn-outline-success" onClick={() => handleRestore(r.id)} title="Restore"><i className="fas fa-undo" /></button></td>
                </tr>
              )) : (
                <tr><td colSpan={13}><center style={{ padding:20, color:"#6c757d" }}>No matching records found</center></td></tr>
              )}
            </tbody>
          </table>
          <Pager cur={delPage} total={delTotalPages} onChange={p => loadDeleted(p)} />
        </div>
      )}
      </>)}

      {/* - MODALS - */}
      {addModalJSX}
      {editModalJSX}
      {updateModalJSX}

      {/* - SweetAlert Dialogs - */}
      {confirm_alert && <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
        onConfirm={() => {
          if (selected.length && !deleteId) handleBulkDelete()
          else fetchDelete()
          setconfirm_alert(false); if(deleteId) setsuccess_dlg(true)
        }}
        onCancel={() => { setconfirm_alert(false); setDeleteId("") }}>You won't be able to revert this!</SweetAlert>}
      {success_dlg && <SweetAlert success title="Done!" onConfirm={() => { setsuccess_dlg(false); setDeleteId(""); setDlgMsg("") }}>{dlgMsg || "Operation completed."}</SweetAlert>}
    </>
  )
}

export default CCSpoiledPurchases

